import React from 'react';
import PropTypes from 'prop-types';

import {Button, ButtonIcon} from '@brandwatch/axiom-components';

import './MobileWelcome.css';
import InviteMessage from './InviteMessage.jsx';

const MobileWelcome = ({acknowledgeMobileWelcome, deck, invite, inviteeCount}) => {
  return (
    <div className="MobileWelcome">
      {invite && invite.invite_id && deck && deck.name && <React.Fragment>
        <InviteMessage
          deck={deck}
          invite={invite}
          inviteeCount={inviteeCount}
          isMobile={true}
        />

        {/* Placeholder button that ensures there is a space for the real button. */}
        <div className="MobileWelcome__AcknowledgePlaceholder">
          <Button full={true} size="large" space="x4">View {deck.name} <ButtonIcon name="chevron-right" /></Button>
        </div>

        {/* Button that's positioned over the placeholder */}
        <div className="MobileWelcome__Acknowledge">
          <Button onClick={acknowledgeMobileWelcome} full={true} size="large" space="x4">
            <div className="MobileWelcome__ButtonContent" data-viz-at="button-acknowledge">
              View {deck.name}</div>
            <ButtonIcon name="chevron-right" />
          </Button>
        </div>
      </React.Fragment>}
    </div>
  );
};

MobileWelcome.propTypes = {
  acknowledgeMobileWelcome: PropTypes.func,
  deck: PropTypes.object,
  invite: PropTypes.object,
  inviteeCount: PropTypes.number
};

export default MobileWelcome;
